var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 900 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M210.938 534.375H267.188V759.375H210.938V534.375ZM351.562 534.375H407.812V759.375H351.562V534.375ZM492.188 534.375H548.438V759.375H492.188V534.375ZM632.812 534.375H689.062V759.375H632.812V534.375Z",
    className: "svgText"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M832.642 295.312L692.687 28.125H629.188L769.143 295.312H130.857L270.812 28.125H207.313L67.3576 295.312H28.125V491.252L103.458 871.875H796.495L871.875 494.972V295.312H832.642ZM815.625 489.403L750.38 815.625H149.667L84.375 485.74V478.125H815.625V489.403ZM815.625 421.875H84.375V351.562H815.625V421.875Z",
    className: "svgText"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.58d8a3a1ea49bf65e52607032415d824.svg";
export { ForwardRef as ReactComponent };